/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class GeneralService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param key
     * @returns any OK
     * @throws ApiError
     */
    public getGeneralDownloadExport(
        key?: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/general/DownloadExport',
            query: {
                'key': key,
            },
        });
    }
}
